import { render, staticRenderFns } from "./IBSRegimeFormMessage.vue?vue&type=template&id=61cad113&scoped=true&"
import script from "./IBSRegimeFormMessage.vue?vue&type=script&lang=js&"
export * from "./IBSRegimeFormMessage.vue?vue&type=script&lang=js&"
import style0 from "./IBSRegimeFormMessage.vue?vue&type=style&index=0&id=61cad113&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cad113",
  null
  
)

export default component.exports